import { getPipelinesBaseUrl as itkWasmGetPipelinesBaseUrl } from "itk-wasm";
import version from "./version.js";
let pipelinesBaseUrl;
let defaultPipelinesBaseUrl = `https://cdn.jsdelivr.net/npm/@itk-wasm/image-io@${version}/dist/pipelines`;
export function setPipelinesBaseUrl(baseUrl) {
    pipelinesBaseUrl = baseUrl;
}
export function getPipelinesBaseUrl() {
    if (typeof pipelinesBaseUrl !== "undefined") {
        return pipelinesBaseUrl;
    }
    const itkWasmPipelinesBaseUrl = itkWasmGetPipelinesBaseUrl();
    if (typeof itkWasmPipelinesBaseUrl !== "undefined") {
        return itkWasmPipelinesBaseUrl;
    }
    return defaultPipelinesBaseUrl;
}
//# sourceMappingURL=pipelines-base-url.js.map